import { useState, useEffect } from 'react';

const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const checkTouchCapability = () => {
      setIsTouchDevice(
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    };

    checkTouchCapability();

    window.addEventListener('touchstart', checkTouchCapability);
    return () => {
      window.removeEventListener('touchstart', checkTouchCapability);
    };
  }, []);

  return isTouchDevice;
};

export default useIsTouchDevice;